/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { JobsControllerGetQueueDepthsQueryResponse, JobsControllerGetQueueDepths401, JobsControllerGetQueueDepths403 } from "../../models/jobsController/JobsControllerGetQueueDepths";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { jobsControllerGetQueueDepths } from "../../clients/jobsService/jobsControllerGetQueueDepths";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const jobsControllerGetQueueDepthsQueryKey = () => [{
  url: '/api/v1/jobs/queue-depths'
}] as const;
export type JobsControllerGetQueueDepthsQueryKey = ReturnType<typeof jobsControllerGetQueueDepthsQueryKey>;
export function jobsControllerGetQueueDepthsQueryOptions(config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = jobsControllerGetQueueDepthsQueryKey();
  return queryOptions<JobsControllerGetQueueDepthsQueryResponse, ResponseErrorConfig<JobsControllerGetQueueDepths401 | JobsControllerGetQueueDepths403>, JobsControllerGetQueueDepthsQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return jobsControllerGetQueueDepths(config);
    }
  });
}

/**
 * @description Returns the number of QUEUED jobs per job queue (std-job-queue, chat-job-queue, transfer-job-queue, cpu-job-queue), counted from the jobs table.
 * @summary Get job queue depths
 * {@link /api/v1/jobs/queue-depths}
 */
export function useJobsControllerGetQueueDepths<TData = JobsControllerGetQueueDepthsQueryResponse, TQueryData = JobsControllerGetQueueDepthsQueryResponse, TQueryKey extends QueryKey = JobsControllerGetQueueDepthsQueryKey>(options: {
  query?: Partial<QueryObserverOptions<JobsControllerGetQueueDepthsQueryResponse, ResponseErrorConfig<JobsControllerGetQueueDepths401 | JobsControllerGetQueueDepths403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? jobsControllerGetQueueDepthsQueryKey();
  const query = useQuery({
    ...jobsControllerGetQueueDepthsQueryOptions(config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<JobsControllerGetQueueDepths401 | JobsControllerGetQueueDepths403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}